
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#E1E6EE"}}),_c('g',{attrs:{"clip-path":"url(#tw-projects-more-down-arrow-icon-clip0_884_5728)"}},[_c('path',{attrs:{"d":"M28 20l-1.41-1.41L21 24.17V12h-2v12.17l-5.58-5.59L12 20l8 8 8-8z","fill":"#8F9BB3"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"tw-projects-more-down-arrow-icon-clip0_884_5728"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8 8)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    